import StarredItem from "../../model2/starred/starred-item"


export default class UserStars {

    constructor() {
    }

    isProjectStarred(projectId:ID) {
        return !!gd.session.starredItems.getProjectStarredItem(projectId)
    }

    addProject(projectId:ID) {
        const request = gd.api.Starred.addToStarred(null,projectId);

        gd.session.starredItems.add(new StarredItem({
            projectId: projectId,
            companyId: gd.companyId
        }))
    }

    removeProject(projectId:ID) {

        const item = gd.session.starredItems.getProjectStarredItem(projectId)

        if (!item) return

        gd.session.starredItems.removeItem(item)

        const request = gd.api.Starred.removeFromStarred(null,projectId)

        request.done((data:any)=>{
            // gd.session.starredItems.removeItem(item)
        });
        request.fail((error:any)=>{
        });
    }

}